import { hmsAPI } from '@/api'

export const getOverlay =  overlayId => hmsAPI.get(`/overlays/${overlayId}`)
export const sendCompareToSegmentation =  compareId => hmsAPI.post(`/compares/${compareId}/apply-segmentation`)
export const updateOverlay =  (overlayId, overlay) => hmsAPI.put(`/overlays/${overlayId}`, overlay)
